// extracted by mini-css-extract-plugin
export default {"Table":"load_Table__0P0H4"};